import React, { useEffect, useState, useCallback, createContext, useContext } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const AcademyContext = createContext({ academy: null, role: null, loading: true, reload: () => {} });

export const AcademyProvider = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [state, setState] = useState({ academy: null, role: null, loading: true });

  const reload = useCallback(() => {
    if (authLoading) return;                             // wait for AuthContext
    if (!user) { setState({ academy: null, role: null, loading: false }); return; }
    setState((s) => ({ ...s, loading: true }));
    api.get("/academies/mine")
      .then(({ data }) => setState({ academy: data.academy, role: data.role, loading: false }))
      .catch(() => setState({ academy: null, role: null, loading: false }));
  }, [user, authLoading]);

  useEffect(() => { reload(); }, [reload]);

  return (
    <AcademyContext.Provider value={{ ...state, reload }}>
      {children}
    </AcademyContext.Provider>
  );
};

export const useAcademy = () => useContext(AcademyContext);
